/**
 * store 汇总, 并建立 store 间通信的桥梁
 * */
import createContext from 'common/store/createStoreContext';
import { disposeOnUnmount } from 'common/store/disposeOnUnmount';
import enhanceStore from 'common/store/enhanceStore';
import { handleError, handleSuccess } from './ErrorHandler';
import AppAuthorization from '../../modules/app-authorization/AppAuthorizationStore';
// 个人认证
import AuthorizationStore from '../../modules/auth/auth/AuthorizationStore';
import InformationStore from '../../modules/auth/information/InformationStore';
import ProgressStore from '../../modules/auth/progress/ProgressStore';
// 企业认证
import EntInformationStore from '../../modules/auth-enterprise/information/EntInformationStore';
import EntProgressStore from '../../modules/auth-enterprise/progress/EntProgressStore';
import InvitationStore from '../../modules/invitation/InvitationStore';
// 登录
import LoginStore from '../../modules/login/LoginStore';
import AccountManageStore from '../../modules/profile/accountManage/AccountManageStore';
import ProfileStore from '../../modules/profile/personalCenter/ProfileStore';
import ResetPasswordStore from '../../modules/reset-password/ResetPasswordStore';
import RootStore from '../../modules/root/RootStore';
// select页面
import SelectAccountStore from '../../modules/select-account/SelectAccountStore';
// 自然人 identity
import SSOLoginIdentityStore from '../../modules/sso-login/identity/SSOLoginIdentityStore';

class GlobalStore {
  public sso = {
    loginIdentityStore: enhanceStore(new SSOLoginIdentityStore(), this),
  };

  public loginStore = enhanceStore(new LoginStore(), this);
  public rootStore = enhanceStore(new RootStore(), this);
  public appAuthorizationStore = enhanceStore(new AppAuthorization(), this);
  public profileStore = enhanceStore(new ProfileStore(), this);
  public invitationStore = enhanceStore(new InvitationStore(), this);
  public resetPasswordStore = enhanceStore(new ResetPasswordStore(), this);
  public accountManageStore = enhanceStore(new AccountManageStore(), this);
  public selectAccountStore = enhanceStore(new SelectAccountStore(), this);

  public auth = {
    informationStore: enhanceStore(new InformationStore(), this),
    progressStore: enhanceStore(new ProgressStore(), this),
    authorizationStore: enhanceStore(new AuthorizationStore(), this),
  };

  public ent = {
    entInformationStore: enhanceStore(new EntInformationStore(), this),
    entProgressStore: enhanceStore(new EntProgressStore(), this),
  };

  public handleError = handleError;
  public handleSuccess = handleSuccess;
}

export type TGlobalStore = GlobalStore;

const { Provider, StoreContext, useStore, inject, convert } = createContext<TGlobalStore>();

export * from 'common/store/baseActions';
export { Observer, useLocalObservable } from 'mobx-react';
export { Provider, StoreContext, useStore, inject, convert, disposeOnUnmount };

export default new GlobalStore();
